import classNames from 'classnames';
import { Link } from 'react-router';

import { getActivityTypeConfig } from 'my-core/online-course-activity-utils';
import { findAncestor, renderContentMap } from 'my-core/online-course-content-map';

import Avatar from '@mui/material/Avatar';
import ButtonBase from '@mui/material/ButtonBase';
import List from '@mui/material/List';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

import { faLongArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const rootCss = ({ breakpoints, palette, shape: { borderRadius }, spacing }) => ({
  overflow: 'auto',
  '.ICSC-paper': {
    padding: spacing(2),
    backgroundColor: palette.background.paper,
  },
  '.ICSC-title': { marginBottom: spacing(1) },
  '.ICSC-item': {
    display: 'flex',
    justifyContent: 'flex-start',
    padding: spacing(1, 2),
    border: `1px solid ${palette.divider}`,
    '&:hover': { backgroundColor: palette.grey[50] },
    '&:first-child': { borderTopLeftRadius: borderRadius, borderTopRightRadius: borderRadius },
    '&:last-child': { borderBottomLeftRadius: borderRadius, borderBottomRightRadius: borderRadius },
    '& + .ICSC-item': { borderTop: 'none' },
  },
  '.ICSC-icon': {
    width: 40,
    height: 40,
    minWidth: 0,
    marginRight: spacing(2),
  },
  '.ICSC-itemText': { flex: 1 },

  [breakpoints.up('sm')]: {
    padding: spacing(1),
    '.ICSC-paper': {
      maxWidth: 600,
      margin: 'auto',
      padding: spacing(4),
      border: `1px solid ${palette.divider}`,
      borderRadius,
    },
  },
});

export default function InCourseExperienceSectionCover({
  activeComponent,
  basePath,
  className,
  iconClassName,
  itemClassName,
  itemTextClassName,
  paperClassName,
  titleClassName,
}) {
  const section = activeComponent.data;
  const chapter = findAncestor(activeComponent, n => n.type === 'chapter');

  return (
    <div className={className} css={rootCss}>
      <div className={classNames('ICSC-paper', paperClassName)}>
        <Typography color="primary" variant="overline">
          {chapter?.fullPos}. {chapter?.data.title}
        </Typography>
        <Typography className={classNames('ICSC-title', titleClassName)} variant="h6">
          {activeComponent?.fullPos} {section.title}
        </Typography>
        <List>
          {renderContentMap(activeComponent, (component, renderChildren) => {
            switch (component.type) {
              case 'section':
                return renderChildren();
              case 'activity': {
                const typeConfig = getActivityTypeConfig(component.data);
                return (
                  <ButtonBase
                    key={component.key}
                    className={classNames('ICSC-item', itemClassName)}
                    component={Link}
                    nativeButton={false}
                    to={`${basePath}${component.fullPath}`}
                  >
                    <Tooltip title={typeConfig.label}>
                      <Avatar className={classNames('ICSC-icon', iconClassName)} src={typeConfig.iconImg} />
                    </Tooltip>
                    <Typography className={classNames('ICSC-itemText', itemTextClassName)}>
                      {component.data.title}
                    </Typography>
                    <FontAwesomeIcon icon={faLongArrowRight} />
                  </ButtonBase>
                );
              }
            }
            return null;
          })}
        </List>
      </div>
    </div>
  );
}
